await loadComponent('./components/mc-element.js', false);

class StoqBtn extends McElement {
  
  connectedCallback() {
    this.addEventListener('click', this.showModal.bind(this));
  }

  showModal = () => {
    if(!this.dataset.productId || !this.dataset.variant) {
      console.error('StoqBtn: Product ID or Variant not set on stoq-btn');
      return;
    }
    if(!window._RestockRocket) {
      console.error('StoqBtn: RestockRocket is not loaded');
      return;
    }
    
    const selectedButton = this;
    const selectedVariantTitle = selectedButton.querySelector('del')?.textContent || 'Variante';
    window.stoqSelectedVariant = {
      id: this.dataset.variant,
      title: selectedVariantTitle
    };
    

    const allUnavailableVariants = [];
    const allButtons = document.querySelectorAll(`stoq-btn[data-product-id="${this.dataset.productId}"]`);
    
    allButtons.forEach(btn => {
      if (btn.dataset.variant) {
        const title = btn.querySelector('del')?.textContent || 'Variante';
        allUnavailableVariants.push({
          id: btn.dataset.variant,
          available: false,
          title: title
        });
      }
    });
    
    const productData = {
      id: this.dataset.productId,
      variants: allUnavailableVariants.length > 0 ? allUnavailableVariants : [{ id: this.dataset.variant, available: false }],
    };
    
    console.log('Opening Stoq modal with product data:', productData);
    window._RestockRocket.openModal(productData, this.dataset.variant);
   
    this.customizePopupForm();
  }

  customizePopupForm = () => {
      const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { 

            const formContainer = node.id === 'restock-rocket' ? node : 
                                 node.querySelector?.('#restock-rocket');
            
            if (formContainer) {
           
              this.modifyForm(formContainer);
              observer.disconnect();
              return;
            }
          }
        });
      });
    });


    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
      
      
      const existingForm = document.querySelector('#restock-rocket');
      if (existingForm) {
        this.modifyForm(existingForm);
      }
    }, 500); 
  }

  modifyForm = (container) => {
    console.log('Popup Stoq trovato, applico modifiche personalizzate');
    
        if (!document.querySelector('#stoq-custom-styles')) {
      const style = document.createElement('style');
      style.id = 'stoq-custom-styles';
      style.textContent = `
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
          20%, 40%, 60%, 80% { transform: translateX(5px); }
        }
        /* Nascondi immediatamente il selettore varianti di Stoq */
        #restock-rocket #form-Select {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
    
  
    const findElements = (callback, maxRetries = 10) => {
      let retries = 0;
      const tryFind = () => {
        const elements = {
          emailInput: container.querySelector('#form-Email'),
          submitButton: container.querySelector('#form-Button'),
          consentCheckbox: container.querySelector('#form-Consent-Input'),
          headerText: container.querySelector('#form-Header-Text'),
          description: container.querySelector('#form-Description'),
          consentContainer: container.querySelector('#form-Consent-Container'),
          emailContainer: container.querySelector('#form-Email-Container')
        };
        
       
        if (elements.submitButton && elements.consentCheckbox) {
          callback(elements);
        } else if (retries < maxRetries) {
          retries++;
          setTimeout(tryFind, 50); 
        }
      };
      tryFind();
    };
    
   
    findElements((elements) => {
      const { emailInput, submitButton, consentCheckbox, headerText, description, consentContainer, emailContainer } = elements;
    
    
    if (emailInput) {
      emailInput.placeholder = 'Inserisci la tua email per la notifica';
      
    
      emailInput.addEventListener('blur', () => {
        const emailValue = emailInput.value;
        if (emailValue && !emailValue.includes('@')) {
          emailInput.style.borderColor = 'red';
          emailInput.setCustomValidity('Inserisci un\'email valida');
        } else {
          emailInput.style.borderColor = '';
          emailInput.setCustomValidity('');
        }
      });
    }

    if (headerText) {

    }
    
   
    const variantSelect = container.querySelector('#form-Select');
    if (variantSelect) {
   
      const productTitle = document.querySelector('h1.product__title')?.textContent || 
                          document.querySelector('.product-title')?.textContent || 
                          document.querySelector('[data-product-title]')?.textContent ||
                          document.querySelector('h1')?.textContent ||
                          'Prodotto';
      
     
      const productTitleElement = document.createElement('div');
      productTitleElement.className = 'product-title-popup';
      productTitleElement.style.cssText = `
        font-weight: 300;
        font-size: 12px;
        color: #000;
        text-align: left;
        padding: 10px 0;
      `;
      productTitleElement.textContent = productTitle.trim();
      
     
      variantSelect.parentNode.insertBefore(productTitleElement, variantSelect);
    
      
   
      const selectedVariantDisplay = document.createElement('div');
      selectedVariantDisplay.className = 'selected-variant-display';
      selectedVariantDisplay.style.cssText = `
        margin-bottom: 15px;
        font-size: 14px;
        color: #000;
      `;
      
   
      const updateVariantDisplay = () => {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (selectedOption) {
          
          const variantId = selectedOption.value;
          const variantText = selectedOption.textContent.trim();

          selectedVariantDisplay.innerHTML = `<strong>Taglia:</strong> ${variantText}`;
        }
      };
      
   
      updateVariantDisplay();
      
   
      variantSelect.parentNode.insertBefore(selectedVariantDisplay, variantSelect.nextSibling);
      
      
      variantSelect.addEventListener('change', updateVariantDisplay);
      
    } else if (emailContainer) {
     
      const productTitle = document.querySelector('h1.product__title')?.textContent || 
                          document.querySelector('.product-title')?.textContent || 
                          document.querySelector('[data-product-title]')?.textContent ||
                          document.querySelector('h1')?.textContent ||
                          'Prodotto';
      
      const productTitleElement = document.createElement('div');
      productTitleElement.className = 'product-title-popup';
      productTitleElement.style.cssText = `
        font-weight: 300;
        font-size: 12px;
        color: #000;
        text-align: left;
        padding: 10px 0;
      `;
      productTitleElement.textContent = productTitle.trim();
      
      emailContainer.parentNode.insertBefore(productTitleElement, emailContainer);
    }
    
   
    if (emailContainer) {
      const phoneField = document.createElement('div');
      phoneField.style.marginTop = '10px';
      phoneField.innerHTML = `
        <label for="form-Phone" class="sr-only">Numero di telefono (opzionale)</label>
        <input id="form-Phone" 
               placeholder="Numero di telefono (opzionale)" 
               type="tel" 
               style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px;">
      `;
      emailContainer.parentNode.insertBefore(phoneField, emailContainer.nextSibling);
    }
    
      if (submitButton) {
   
      if (!submitButton.querySelector('.bell-icon')) {
        const buttonText = submitButton.textContent;
        submitButton.innerHTML = `
          <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
            <svg class="bell-icon" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" style="display: inline-block;">
              <path d="M8 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2zm6-5v-4c0-3.07-1.64-5.64-4.5-6.32V0C9.5 0 9 0 8 0s-1.5 0-1.5 0v.68C3.63 1.36 2 3.92 2 7v4l-2 2v1h16v-1l-2-2zm-2 1H4v-5c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v5z"/>
            </svg>
            ${buttonText}
          </span>
        `;
      }
      

      submitButton.addEventListener('click', (e) => {
        console.log('Intercettato click pulsante Stoq');
        
      
        const email = container.querySelector('#form-Email')?.value;
        const phone = container.querySelector('#form-Phone')?.value;
        const consent = container.querySelector('#form-Consent-Input')?.checked;
        
        console.log('Dati form:', { email, phone, consent });
        
      
        if (!email) {
          alert('Inserisci la tua email');
             return;
        }
        
      
        if (phone) {
         
          fetch('/your-endpoint', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, phone, productId: this.dataset.productId })
          }).catch(err => console.log('Errore invio dati custom:', err));
        }
        
        // NON preveniamo il default - lasciamo che Stoq proceda normalmente
      }, false); // useCapture: false per assicurarci che il nostro listener venga eseguito prima
      
      // Modifica stile del bottone se necessario
      // submitButton.style.backgroundColor = '#ff0000';
      // submitButton.textContent = 'NOTIFICAMI';
    }
    
    // Esempio 5: Pre-seleziona il checkbox del consenso
    if (consentCheckbox) {
      // consentCheckbox.checked = true;
    }
        
    // Disabilita il pulsante se il checkbox del consenso non è selezionato
    if (consentCheckbox && submitButton && consentContainer) {
      // Usa lo stesso ID di Stoq per il messaggio di errore
      let privacyError = container.querySelector('#form-Error-Message');
      
   
      if (!privacyError) {
        privacyError = document.createElement('div');
        privacyError.id = 'form-Error-Message';
   
        privacyError.style.cssText = `
          color: #dc3545;
          font-size: 14px;
          margin-bottom: 10px;
          display: none;
          font-family: inherit;
        `;
                submitButton.parentNode.insertBefore(privacyError, submitButton);
      }
      
    
      const checkmark = container.querySelector('#form-Consent-Checkmark');
      
     
      const updateButtonState = (showError = false) => {
        if (!consentCheckbox.checked) {
          submitButton.disabled = true;
          submitButton.style.opacity = '0.5';
          submitButton.style.cursor = 'not-allowed';
          
     
          if (showError) {
            if (checkmark) {
              checkmark.style.border = '2px solid #dc3545';
              checkmark.style.boxShadow = '0 0 0 0.2rem rgba(220,53,69,.25)';
            }
            privacyError.textContent = 'Per procedere è necessario accettare la clausola sulla privacy.';
            privacyError.style.display = 'block';
          }
        } else {
          submitButton.disabled = false;
          submitButton.style.opacity = '1';
          submitButton.style.cursor = 'pointer';
          
        
          if (checkmark) {
            checkmark.style.border = '';
            checkmark.style.boxShadow = '';
          }
          
      
          privacyError.style.display = 'none';
          privacyError.textContent = '';
        }
      };
      
      // NON mostrare errore all'inizio, solo disabilita il pulsante
      updateButtonState(false);
      
   
      consentCheckbox.addEventListener('change', () => updateButtonState(false));
      
      
      consentContainer.addEventListener('click', () => {
        setTimeout(() => updateButtonState(false), 10);
      });
      
      
      submitButton.addEventListener('click', (e) => {
        // Controlla se l'email è compilata - cerca direttamente l'elemento
        const currentEmailInput = container.querySelector('#form-Email');
        const emailValue = currentEmailInput ? currentEmailInput.value.trim() : '';
        
        if (!consentCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          
          // Mostra sempre l'errore quando si clicca sul bottone e il checkbox non è selezionato
          // ma solo se l'email è compilata
          if (emailValue) {
            privacyError.textContent = 'Per procedere è necessario accettare la clausola sulla privacy.';
            privacyError.style.display = 'block';
            
            if (checkmark) {
              checkmark.style.border = '2px solid #dc3545';
              checkmark.style.boxShadow = '0 0 0 0.2rem rgba(220,53,69,.25)';
              checkmark.style.animation = 'shake 0.5s';
              setTimeout(() => {
                checkmark.style.animation = '';
              }, 500);
            }
            
            consentContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, true);
      
      // Aggiungi anche un listener per il click quando il bottone è disabilitato
      submitButton.parentElement.addEventListener('click', (e) => {
        if (submitButton.disabled && e.target === submitButton) {
          // Se il bottone è disabilitato e il checkbox non è selezionato, mostra sempre l'errore
          if (!consentCheckbox.checked) {
            privacyError.textContent = 'Per procedere è necessario accettare la clausola sulla privacy.';
            privacyError.style.display = 'block';
            
            if (checkmark) {
              checkmark.style.border = '2px solid #dc3545';
              checkmark.style.boxShadow = '0 0 0 0.2rem rgba(220,53,69,.25)';
              checkmark.style.animation = 'shake 0.5s';
              setTimeout(() => {
                checkmark.style.animation = '';
              }, 500);
            }
            
            consentContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }, true);
    }
    
  
    const observeMessages = () => {
      const messageObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Gestisci messaggi di errore
              if (node.id === 'form-Error-Message') {
                console.log('Messaggio di errore Stoq rilevato:', node.textContent);
              }
              
           
              if (node.id === 'form-Success-Container' || node.querySelector?.('#form-Success-Container')) {
                setTimeout(() => {
                  const successContainer = container.querySelector('#form-Success-Container');
                  const successText = container.querySelector('#form-Success-Text');
                  
                  if (successContainer && successText && !successContainer.querySelector('.product-success-info')) {
                  
                    const productTitle = document.querySelector('h1.product__title')?.textContent || 
                                       document.querySelector('.product-title')?.textContent || 
                                       document.querySelector('[data-product-title]')?.textContent ||
                                       document.querySelector('h1')?.textContent ||
                                       'Prodotto';
                    
                    
                    let variantText = '';
                    if (window.stoqSelectedVariant && window.stoqSelectedVariant.title) {
                      variantText = window.stoqSelectedVariant.title;
                    } else {
                      
                      const variantSelect = container.querySelector('#form-Select');
                      if (variantSelect && variantSelect.selectedIndex >= 0) {
                        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
                        variantText = selectedOption ? selectedOption.textContent.trim() : '';
                      }
                    }
                    
                   
                    const productInfo = document.createElement('div');
                    productInfo.className = 'product-success-info';
                    productInfo.style.cssText = `
                      margin-top: 15px;
                      padding: 10px;
                      border-radius: 4px;
                      font-size: 14px;
                      color: #333;
                    `;
                    productInfo.innerHTML = `
                      <div><strong>Prodotto:</strong> ${productTitle.trim()}</div>
                      ${variantText ? `<div><strong>Taglia:</strong> ${variantText}</div>` : ''}
                    `;
                    
                   
                    successText.parentNode.insertBefore(productInfo, successText.nextSibling);
                  }
                }, 100);
              }
            }
          });
        });
      });
      
      messageObserver.observe(container, {
        childList: true,
        subtree: true
      });
    };
    
    observeMessages();
    }); 
  }

}
if(!customElements.get('stoq-btn')){
  customElements.define('stoq-btn', StoqBtn);
}
window.StoqBtn = StoqBtn;
export default StoqBtn;